var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.931 2.02a8.91 8.91 0 0 1 8.912 8.91 8.88 8.88 0 0 1-2.202 5.862l4.106 4.105a.601.601 0 0 1-.85.848l-4.104-4.105a8.88 8.88 0 0 1-5.862 2.203 8.912 8.912 0 0 1 0-17.823m0 1.199a7.713 7.713 0 0 0 0 15.424c2.104 0 4.01-.845 5.402-2.211q.02-.029.045-.055.028-.026.057-.048a7.68 7.68 0 0 0 2.208-5.398 7.71 7.71 0 0 0-7.712-7.712m.001 4.095a.5.5 0 0 1 .5.5v2.617h2.617a.5.5 0 0 1 0 1h-2.617v2.617a.5.5 0 0 1-1 0v-2.617H7.815a.5.5 0 0 1 0-1h2.617V7.814a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgZoomIn;